export var LoginViews;
(function (LoginViews) {
    LoginViews["LOGIN"] = "login";
    LoginViews["SIGNUP"] = "signup";
    LoginViews["VERIFICATION"] = "verification";
    LoginViews["LOGIN_WITH_OTP"] = "loginWithOTP";
    LoginViews["MESSAGE_INFO"] = "info";
})(LoginViews || (LoginViews = {}));
